import { useEffect, useRef } from 'react';

const isDefined = val => val != null;

/**
 * Wraps `setTimeout`. Triggers the function after a given delay.
 */

export default function useTimeout(fn, delay) {
    const savedCallback = useRef();

    useEffect(() => {
        savedCallback.current = fn;
    });

    useEffect(() => {
        function cb() {
            savedCallback.current();
        }
        if (isDefined(delay)) {
            const id = setTimeout(cb, delay);
            return () => clearTimeout(id);
        }
    }, [delay]);
}
